<template lang="pug">
  canvas#canvas(ref="ocrCanvas")
</template>

<script>
// 此组件只显示数据, 不提交数据返回, 所以需要拷贝数据
export default {
  name: 'OcrCanvas',

  data () {
    return {
      ctx: null,
      result: [],
      ratio: 1
    }
  },

  mounted () {
    this.ctx = this.$refs.ocrCanvas.getContext('2d')
  },

  methods: {
    // 将图片绘制到canvas上
    drawCanvas (result, imageUrl) {
      const that = this
      that.result = JSON.parse(JSON.stringify(result))
      var img = new Image()
      if (imageUrl) img.src = imageUrl
      img.onload = function () {
        const boxWidth = 677
        let ratio = 1
        if (this.naturalWidth > boxWidth) {
          ratio = this.naturalWidth / boxWidth
          that.$refs.ocrCanvas.width = boxWidth
          that.$refs.ocrCanvas.height = this.naturalHeight / ratio
        } else {
          that.$refs.ocrCanvas.width = this.naturalWidth
          that.$refs.ocrCanvas.height = this.naturalHeight
        }
        that.ratio = ratio
        that.$refs.ocrCanvas.style.backgroundImage = 'url(' + imageUrl + ')'
        that.$refs.ocrCanvas.style.backgroundSize = `${this.naturalWidth / ratio}px ${this.naturalHeight / ratio}px`
        that._drawRects(that.result)
      }
      this.$refs.ocrCanvas.addEventListener('click', e => {
        this._isClickOcrRegion(e.layerX, e.layerY)
      })
    },

    // 绘制选区
    _drawRects (items) {
      // 此处的items 引入了外部的数据
      if (this.ratio !== 1) {
        items = items.map(item => {
          for (const key in item.coord) {
            item.coord[key] = item.coord[key] / this.ratio
          }
          return item
        })
      }
      for (const item of items) {
        const coord = item.coord
        this.ctx.beginPath()
        this.ctx.strokeStyle = item.color || '#409eff'
        this.ctx.rect(coord.x, coord.y, coord.w, coord.h)
        this.ctx.closePath()
        this.ctx.stroke()
      }
    },

    // 监听点击区域
    _isClickOcrRegion (x, y) {
      const index = this.result.findIndex(({ coord }) => {
        if (x >= coord.x && x <= coord.x + coord.w && y >= coord.y && y <= coord.y + coord.h) return true
      })
      if (index !== -1) this.$emit('clickTextArea', index)
    },

    // 重新绘制整个区域(删除需要)
    reRenderOcrCanvas (result) {
      this.ctx.clearRect(0, 0, this.$refs.ocrCanvas.width, this.$refs.ocrCanvas.height)
      this._drawRects(JSON.parse(JSON.stringify(result)))
    }

  }
}
</script>

<style scoped>
#canvas {
  border: 1px solid #696;
  box-shadow: #666 0px 0px 10px;
  position: relative;
}
</style>
